import { Content } from '@radix-ui/react-collapsible'
import React from 'react'

import { cn } from '~/styled'

import { TreeCollapsibleContext } from './TreeCollapsible'
import { TreeList } from './TreeList'

type TreeCollapsibleContentProps = React.ComponentProps<typeof Content> &
  React.ComponentProps<typeof TreeList>

export const TreeCollapsibleContent = React.forwardRef<
  HTMLUListElement,
  TreeCollapsibleContentProps
>(({ children, className, ...rest }, ref): React.JSX.Element => {
  const { triggerRef } = React.useContext(TreeCollapsibleContext)

  const handleOnKeydown = (e) => {
    if (!triggerRef?.current) return
    if (e.key === 'Escape') {
      e.stopPropagation()
      e.preventDefault()
      triggerRef.current.focus()
      triggerRef.current.click()
    }
  }

  return (
    <Content
      className={cn('data-[state=closed]:hidden', className)}
      onKeyDown={handleOnKeydown}
      {...rest}
      asChild
    >
      <TreeList ref={ref} role="group">
        {children}
      </TreeList>
    </Content>
  )
})
